import { render, staticRenderFns } from "./rightCont.vue?vue&type=template&id=4b315f3e&"
import script from "./rightCont.vue?vue&type=script&lang=js&"
export * from "./rightCont.vue?vue&type=script&lang=js&"
import style0 from "./rightCont.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports